<template>
  <div>
    <layout headerTitle="Sistema de vigilancia epidemiológico">
      <template #container>
        <b-row class="pt-4 pb-5">
          <div style="display: flex; left: 15px; margin-bottom: 10px">
            <label class="mr-2 breadcrumb-link"
              ><button
                class="mt-0 p-0 pb-1 d-flex align-items-center breadcrumb-link back"
                style="
                  border: none;
                  background-color: transparent;
                  font-size: 16px;
                "
                @click.prevent="back"
              >
                Volver atrás
              </button></label
            >
          </div>
          <b-col cols="12">
            <img
              alt="group"
              :src="require('@/assets/modules/health-tracker/icon/group.svg')"
            />
            <strong class="pl-2">Calificaciones</strong>
          </b-col>
        </b-row>

        <b-row class="mb-5">
          <b-col cols="12">
            <strong>Datos del trabajador</strong>
            <worker-information :id="employeeId" />
          </b-col>
        </b-row>

        <b-row class="mt-5 mb-5">
          <b-col cols="auto" class="mr-auto">
            <strong>Listado de Calificaciones</strong>
          </b-col>
          <b-col cols="auto">
            <button class="button-primary" @click.prevent="createQualification">
              <span
                >Agregar nueva calificación
                <img class="pl-1 mb-1" src="@/assets/images/icons/add.svg"
              /></span>
            </button>
          </b-col>
        </b-row>
        <b-row class="mt-5 mb-5">
          <b-col cols="12">
            <TableListQualification
              :isLoading="isLoading"
              :califications="califications"
              @deleteItem="deleteItem"
            />
          </b-col>
        </b-row>
      </template>
    </layout>
    <!-- 4 MODAL Confirmación-->
    <modal-confirm
      :loading="loading2"
      @deleteItem="deleteCalification"
      :confirmation="confirmation"
    />

    <!-- 3 MODAL PROCESO EXITOSO  -->
    <modal-success :messageModal="messageModal" />

    <!-- 4 MODAL PROCESO FALLIDO -->
    <modal-error :error="error" />
  </div>
</template>
<script>
import { getCalifications, deleteQualification } from "@/services/health-tracker/diagnostic/service";
import TableListQualification from "./components/TableListQualification.vue";
import ModalSuccess from "@/views/SVE/modals/ModalSuccess.vue";
import ModalError from "@/views/SVE/modals/ModalError.vue";
import ModalConfirm from "@/views/SVE/modals/ModalConfirm.vue";

export default {
  name: "listQualification",
  components: {
    layout: () => import("@/layouts/modules/health-tracker/v2/app.vue"),
    WorkerInformation: () =>
      import(
        "@/components/Modules/HealthTracker/V2/Common/WorkerInformation/WorkerInformation.vue"
      ),
    TableListQualification,
    ModalSuccess,
    ModalError,
    ModalConfirm,
  },
  data() {
    return {
      califications: [],
      isLoading: false,
      loading2: false,
      messageModal: "",
      confirmation: {},
      error: {},
      idDelete: null,
    };
  },
  computed: {
    employeeId() {
      return parseInt(this.$route.params.employee_id || "0");
    },
    diagnosticId() {
      return parseInt(this.$route.params.diagnostic_id || "0");
    },
  },
  methods: {
    createQualification() {
      const me = this;
      me.$router.push({
        name: "createQualification",
        params: {
          employee_id: me.employeeId,
          diagnostic_id: me.diagnosticId,
          is_edit: true,
        },
      });
    },
    back() {
      const me = this;
      me.$router.push({
        name: "sve",
        params: {
          category: "diagnostics-register",
          type: me.employeeId,
        },
      });
    },
    async loadCalifications() {
      const me = this;
      me.isLoading = true;
      me.califications = [];
      try {
        const { result } = await getCalifications(me.diagnosticId);
        me.califications = result?.data;
      } catch (error) {
        console.log(error);
      } finally {
        me.isLoading = false;
      }
    },
    deleteItem(id) {
      const me = this;
      me.idDelete = id;
      me.confirmation = {
        type: "delete",
        text: `¿Estás seguro de eliminar esta calificación?`,
      };
      me.$bvModal.show("modal-confirm");
    },
    async deleteCalification() {
      const me = this;
      try {
        me.loading2 = true;
        await deleteQualification(me.idDelete);
        me.idDelete = null;
        me.messageModal = `Has Borrado la calificación`;
        me.$bvModal.show("modal-success");
        me.$bvModal.hide("modal-confirm");
        me.loadCalifications();
      } catch (error) {
        me.error = error;
        me.$bvModal.hide("modal-confirm");
        me.$bvModal.show("modal-fail");
      } finally {
        me.loading2 = false;
      }
    },
  },
  beforeMount() {
    const me = this;
    me.loadCalifications();
    if (me.employeeId < 1)
      return me.$router.push({ name: "errorPage", params: { code: 400 } });
  },
};
</script>
<style lang="scss">
.breadcrumb-link {
  color: #5d5fef;
  font-family: "Ubuntu";
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
  margin-top: 0.125em;
}
</style>
